import { Box, Divider, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { ROLE_MAPPING } from "../../../shared/constants/constants";
import store from "../../../store/store";
import { getPartyContactDetails } from "../../../store/api/order";
import PermissionsGate, { PartyRoleBasedPermissionsGate, RoleBasedPermissionsGate } from "../../privateRoute/permissionsGate";
import { PLATFORM_PERMISSIONS, PLATFORM_ROLES } from "../../../shared/models/abacConfig";
type Props = {
  user: any;
  handleUpdate: (user:any) => void;
  handleDelete: (arg0:any, arg1:any) => void;
  relations: any
};
const UserBox = ({ user, handleUpdate, handleDelete, relations }: Props) => {
  const [openAction, setOpenAction] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  useEffect(() => {
    user &&
      user?._id &&
      store
        .dispatch(getPartyContactDetails(user?._id))
        .unwrap()
        .then((res: any) => {
          const emailTemp = res?.data?.filter(
            (con: any) => con?.purposeType[0] === "PRIMARY_EMAIL"
          );
          const phoneTemp = res?.data?.filter(
            (con: any) => con?.purposeType[0] === "PRIMARY_PHONE"
          );
          setEmail(emailTemp[0]?.detail);
          setPhone(phoneTemp[0]?.detail);
        });
  }, [user]);
  const handleOpenAction = () => {
    setOpenAction(!openAction);
  };
  const handleUpdateClicked = () => {
    const userDetails = {
      ...user,
      phone,
      email,
    };
    handleUpdate(userDetails);
  };
  const handleDeleteClicked = (relations: any) => {
    const userDetails = {
      ...user,
      phone,
      email,
    };
    handleDelete(user?._id, relations);
    // console.log(userDetails)
  };
  return (
    <Box>
      <Box className="userBoxHeader">
        <Typography className="userName">{user?.details?.name}</Typography>
        {
          <RoleBasedPermissionsGate roles={[PLATFORM_ROLES.SOCIETY]}>
            <PermissionsGate
              permissions={[
                PLATFORM_PERMISSIONS.PARTYMGR_UPDATE,
                PLATFORM_PERMISSIONS.PARTYMGR_DELETE,
              ]}>
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: { xs: "5em", md: "5.5em" },
                    justifyContent: "space-around",
                  }}
                  onClick={handleOpenAction}
                >
                  <Typography
                    sx={{
                      cursor: "pointer",
                      color: "#22438C",
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "24px",
                    }}
                  >
                    Action
                  </Typography>
                  <KeyboardArrowDownIcon
                    sx={{ color: "#22438C", cursor: "pointer" }}
                  />
                </Box>
                <Box
                  sx={{
                    display: openAction ? "block" : "none",
                    position: "absolute",
                    width: "140%",
                    top: "35px",
                    boxShadow: "-1px 4px 8px 0px #00000040",
                    right: "12px",
                  }}
                >
                  <PermissionsGate
                    permissions={[PLATFORM_PERMISSIONS.PARTYMGR_UPDATE]}
                  >
                    <MenuItem
                      value={"Edit"}
                      className="userMenuItems"
                      onClick={handleUpdateClicked}
                    >
                      <ModeEditOutlineOutlinedIcon />{" "}
                      <Typography>Edit</Typography>
                    </MenuItem>
                  </PermissionsGate>
                  <Divider variant="middle"
                    sx={{
                      marginTop: "2px !important",
                      marginBottom: "2px !important",
                    }}
                  />
                  <PermissionsGate
                    permissions={[PLATFORM_PERMISSIONS.PARTYMGR_DELETE]}
                  >
                    <MenuItem
                      value={"Delete"}
                      className="userMenuItems"
                      onClick={() => handleDeleteClicked(relations)}
                    >
                      <DeleteForeverOutlinedIcon />
                      <Typography>Remove</Typography>
                    </MenuItem>
                  </PermissionsGate>
                </Box>
              </Box>
            </PermissionsGate>
          </RoleBasedPermissionsGate>
        }
      </Box>
      <Box className="userBoxContent">
        <Box className="userDetails">
          <Typography className="userDetailTitle">Designation</Typography>
          <Typography className="userDetailContent">
            {user?.roles?.[0] in ROLE_MAPPING
              ? ROLE_MAPPING[user?.roles?.[0] as keyof typeof ROLE_MAPPING]
              : user?.roles?.[0]}
          </Typography>
        </Box>
        <Box className="userDetails">
          <Typography className="userDetailTitle">E-mail</Typography>
          <Typography className="userDetailContent">{email}</Typography>
        </Box>
        <Box className="userDetails">
          <Typography className="userDetailTitle">Phone number</Typography>
          <Typography className="userDetailContent">{phone}</Typography>
        </Box>
        <Box className="userDetails">
          <Typography className="userDetailTitle">Level</Typography>
          <Typography className="userDetailContent">
            {user?.roles && user?.roles.length > 1
              ? user?.roles[1] in ROLE_MAPPING
                ? ROLE_MAPPING[user?.roles[1] as keyof typeof ROLE_MAPPING]
                : user?.roles[1]
              : "-"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UserBox;
